import React from 'react'
import { Menu, ButtonLanguage } from './index.styled'

function MenuLanguageAudioComponent ({handlerChangeLanguage, currentLanguage}) {
  return (
    <Menu>
      <ButtonLanguage className={currentLanguage === 'pt' ? 'active' : ''} onClick={() => handlerChangeLanguage('pt')}>PT</ButtonLanguage>
      <ButtonLanguage className={currentLanguage === 'en' ? 'active' : ''} onClick={() => handlerChangeLanguage('en')}>EN</ButtonLanguage>
    </Menu>
  )
}

export default MenuLanguageAudioComponent
